(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gl-living-worlds-home"] && !Shopify.designMode) return;
  try {
    
  class GlLivingHome extends HTMLElement {
    connectedCallback() {
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.matchMedia('(max-width: 749px)').matches;
      if (this.reduceMotion) return;
      this.classList.add('gl-living-home--motion');
      this.revealObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('gl-is-visible');
          this.revealObserver.unobserve(entry.target);
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
      for (const item of this.querySelectorAll('[data-gl-reveal]')) this.revealObserver.observe(item);
      this.lineObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const stations = entry.target.querySelectorAll('li');
          for (const [index, station] of stations.entries()) {
            window.setTimeout(() => station.style.setProperty('--gl-progress', '1'), index * 160);
          }
          this.lineObserver.unobserve(entry.target);
        }
      }, { threshold: 0.3 });
      const line = this.querySelector('[data-gl-line]');
      if (line) this.lineObserver.observe(line);
      this.scene = this.querySelector('[data-gl-scene]');
      this.onPointerMove = this.handlePointerMove.bind(this);
      this.scene?.addEventListener('pointermove', this.onPointerMove, { passive: true });
      this.scene?.addEventListener('pointerleave', () => this.resetScene(), { passive: true });
    }

    disconnectedCallback() {
      this.revealObserver?.disconnect();
      this.lineObserver?.disconnect();
      this.scene?.removeEventListener('pointermove', this.onPointerMove);
    }

    handlePointerMove(event) {
      if (!this.scene || window.innerWidth < 990) return;
      const box = this.scene.getBoundingClientRect();
      const x = (event.clientX - box.left) / box.width - .5;
      const y = (event.clientY - box.top) / box.height - .5;
      for (const item of this.scene.querySelectorAll('[data-gl-object]')) {
        const depth = Number(item.dataset.depth || 1);
        item.style.setProperty('--gl-x', `${x * depth * 9}px`);
        item.style.setProperty('--gl-y', `${y * depth * 9}px`);
      }
    }

    resetScene() {
      if (!this.scene) return;
      for (const item of this.scene.querySelectorAll('[data-gl-object]')) {
        item.style.setProperty('--gl-x', '0px');
        item.style.setProperty('--gl-y', '0px');
      }
    }
  }

  if (!customElements.get('gl-living-home')) customElements.define('gl-living-home', GlLivingHome);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-superos-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gl-superos-home')) {
    class GlSuperosHome extends HTMLElement {
      connectedCallback() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.dataset.glReady = 'true';
        const hero = this.querySelector('[data-gl-hero]');
        const revealItems = this.querySelectorAll('[data-gl-reveal]');
        if (!reduce && 'IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
            if (entry.isIntersecting) { entry.target.dataset.glVisible = 'true'; observer.unobserve(entry.target); }
          }), { threshold: 0.12 });
          revealItems.forEach((item) => observer.observe(item));
        } else revealItems.forEach((item) => { item.dataset.glVisible = 'true'; });
        if (!reduce && hero && window.matchMedia('(hover: hover)').matches) {
          hero.addEventListener('pointermove', (event) => {
            const box = hero.getBoundingClientRect();
            const x = (event.clientX - box.left) / box.width - .5;
            const y = (event.clientY - box.top) / box.height - .5;
            hero.style.setProperty('--gl-pointer-x', `${x * 10}px`);
            hero.style.setProperty('--gl-pointer-y', `${y * 10}px`);
            const media = hero.querySelector('.gl-superos-home__hero-media img');
            if (media) media.style.transform = `scale(1.04) translate3d(${x * -10}px, ${y * -8}px, 0)`;
          });
          hero.addEventListener('pointerleave', () => { const media = hero.querySelector('.gl-superos-home__hero-media img'); if (media) media.style.transform = ''; });
        }
      }
    }
    customElements.define('gl-superos-home', GlSuperosHome);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
